import firebase from "firebase";

// The Cloud Functions for Firebase SDK to create Cloud Functions and setup triggers.
// const functions = require('firebase-functions');

// The Firebase Admin SDK to access Cloud Firestore.
// const admin = require('firebase-admin');
// admin.initializeApp();

const firebaseConfig = {
    apiKey: "AIzaSyAALta812KirkujZ5tuGFQyWkEnch3OwXY",
    authDomain: "fakebook-8379d.firebaseapp.com",
    databaseURL: "https://fakebook-8379d.firebaseio.com",
    projectId: "fakebook-8379d",
    storageBucket: "fakebook-8379d.appspot.com",
    messagingSenderId: "147627730334",
    appId: "1:147627730334:web:ac747cbdf9e8869fc4228f",
    measurementId: "G-81LQQYMKRY",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();

// var provider = new firebase.auth.GoogleAuthProvider();

const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
